import React, { PureComponent } from "react";
import { Panel, Columns } from "react-bulma-components";
import { isEmpty } from "lodash";

import Participant from "../Participant/Participant";
import LocalParticipant from "../Participant/LocalParticipant";
import EventSubscriber from "../EventSubscriber/EventSubscriber";

const EVENTS = [
  "dominantSpeakerChanged",
  "participantConnected",
  "participantDisconnected",
  "reconnected",
  "reconnecting",
  "trackDimensionsChanged",
  "trackDisabled",
  "trackEnabled",
  "trackPublished",
  "trackStarted",
  "trackSubscribed",
  "trackUnpublished",
  "trackUnsubscribed",
];

class VideoRoom extends PureComponent<{ videoRoom?: any }> {
  update = () => this.forceUpdate();

  render() {
    const { videoRoom } = this.props;
    const remoteParticipants: any = Array.from(videoRoom.participants.values());
    console.log(remoteParticipants);
    return (
      <EventSubscriber
        events={EVENTS}
        eventEmitterObject={videoRoom}
        onUpdate={this.update}
      >
        <Columns>
          <Columns.Column>
            <Panel>
              {remoteParticipants?.[0] && (
                <Panel.Block paddingless className="video-remote-wrapper">
                  <Participant
                    className=""
                    key={remoteParticipants?.[0]?.sid}
                    isRemote={true}
                    participant={remoteParticipants?.[0]}
                  />
                </Panel.Block>
              )}
            </Panel>
          </Columns.Column>

          <Columns.Column>
            <Panel>
              <Panel.Block paddingless={!isEmpty(remoteParticipants)}>
                {!isEmpty(remoteParticipants) ? (
                  <React.Fragment>
                    <div className="remote-participant-list">
                      {remoteParticipants.slice(1).map((participant: any) => (
                        <Participant
                          className="mt-5 remote-participant"
                          key={participant.sid}
                          isRemote={true}
                          participant={participant}
                        />
                      ))}
                    </div>

                  </React.Fragment>
                ) : (
                  <div className="page-alert">
                    <h4>No participants</h4>
                    <p>Waiting for someone to connect...</p>
                  </div>
                )}
              </Panel.Block>
            </Panel>
          </Columns.Column>

          <Columns.Column>
            <Panel>
              <Panel.Block paddingless>
                <LocalParticipant participant={videoRoom.localParticipant} />
              </Panel.Block>
            </Panel>
          </Columns.Column>
        </Columns>
      </EventSubscriber>
    );
  }
}

export default VideoRoom;
